import { IonIcon } from '@ionic/react';

interface EmptyStateProps {
  /** ionicons icon name (e.g. rocketOutline). */
  icon: string;
  title: string;
  body?: string;
  action?: React.ReactNode;
}

export default function EmptyState({ icon, title, body, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <IonIcon icon={icon} />
      <h6 style={{ fontWeight: 700 }}>{title}</h6>
      {body && <p style={{ fontSize: '0.9rem' }}>{body}</p>}
      {action}
    </div>
  );
}
